module.exports = __webpack_public_path__ + "img/7L.971144de.png";